import * as React from 'react';

import { SlideOut } from '@components/common';

import { QuestionConfigContainer } from './QuestionConfigContainer';
import { QuestionConfigSlideoutFooter } from './QuestionConfigSlideoutFooter';
import { QuestionRulesProvider, useQuestionRulesContext } from './QuestionRulesContext';

type SlideoutMode = 'question_rules' | 'screener_config';

interface BaseProps {
  open: boolean;
  onClose: () => void;
  screener: Screener;
  mode?: SlideoutMode;
}

interface QuestionRulesProps extends BaseProps {
  mode?: 'question_rules';
  question: ScreenerField;
  setQuestions: (questions: ScreenerField[]) => void;
  study?: never;
  onSave?: never;
}

const QuestionConfigSlideoutContent: React.FC = () => {
  const questionRulesData = useQuestionRulesContext();

  const renderFooter = () => {
    return (
      <QuestionConfigSlideoutFooter
        isLoading={questionRulesData.isLoading}
        groupedRules={questionRulesData.groupedRules}
        onSave={questionRulesData.handleSave}
        onCancel={questionRulesData.onClose}
        onRemoveAll={questionRulesData.onRemoveAll}
      />
    );
  };

  return (
    <SlideOut
      title={'Logic and answer tagging'}
      onClose={questionRulesData.onClose}
      renderFooter={renderFooter}
      size='xl'
    >
      <QuestionConfigContainer />
    </SlideOut>
  );
};

export const QuestionConfigSlideout: React.FC<QuestionRulesProps> = ({
  question,
  open,
  onClose,
  screener,
  setQuestions
}) => {
  if (!open) {
    return null;
  }

  return (
    <QuestionRulesProvider question={question} screener={screener} onClose={onClose} setQuestions={setQuestions}>
      <QuestionConfigSlideoutContent />
    </QuestionRulesProvider>
  );
};
